// Settings screen: partners manage the three editable lookup lists. Data and
// refresh come from the shared LookupsContext — after any edit we call reload()
// so every dropdown and label across the app updates too.
import { useLookups } from '../../context/LookupsContext';
import he from '../../i18n/he';
import PageHeader from '../../components/PageHeader';
import AsyncBoundary from '../../components/Loader';
import ListEditor from './ListEditor';

export default function Settings() {
  const lookups = useLookups();

  const lists = [
    { listKey: 'revenue-streams', title: he.settings.streams, rows: lookups.raw.revenueStreams, hasDays: false, emptyText: he.empty.revenueStreams },
    { listKey: 'payment-methods', title: he.settings.methods, rows: lookups.raw.paymentMethods, hasDays: false, emptyText: he.empty.paymentMethods },
    { listKey: 'payment-terms', title: he.settings.terms, rows: lookups.raw.paymentTerms, hasDays: true, emptyText: he.empty.paymentTerms },
    { listKey: 'lead-sources', title: he.settings.sources, rows: lookups.raw.leadSources, hasDays: false, emptyText: he.empty.leadSources },
    { listKey: 'expense-categories', title: he.settings.categories, rows: lookups.raw.expenseCategories, hasContext: true, emptyText: he.empty.expenseCategories },
    { listKey: 'income-categories', title: he.settings.incomeCategories, rows: lookups.raw.incomeCategories, hasDays: false, emptyText: he.empty.incomeCategories },
    { listKey: 'outlets', title: he.settings.outlets, rows: lookups.raw.outlets, hasDays: false, emptyText: he.empty.outlets },
    { listKey: 'document-categories', title: he.settings.documentCategories, rows: lookups.raw.documentCategories, hasDays: false, emptyText: he.empty.documentCategories },
  ];

  return (
    <>
      <PageHeader title={he.settings.title} />
      <AsyncBoundary loading={lookups.loading} error={null}>
        {lists.map((l) => (
          <ListEditor key={l.listKey} {...l} onChanged={lookups.reload} />
        ))}
      </AsyncBoundary>
    </>
  );
}
